module.exports = __webpack_public_path__ + "img/guanxiaoxiao_20210901114715.77332aa9.png";